import {
  type Api,
  type BaseQueryFn,
  type coreModuleName,
  createApi,
  type FetchArgs,
  fetchBaseQuery,
  type FetchBaseQueryError,
  type FetchBaseQueryMeta,
  type reactHooksModuleName
} from '@reduxjs/toolkit/dist/query/react'

export const baseSplitApi = createApi({
  reducerPath: 'base',
  baseQuery: fetchBaseQuery({
    baseUrl: `/api`
  }),
  tagTypes: ['Category'],
  endpoints: () => ({})
})

export type BaseSplitApiExtendable = Api<
  BaseQueryFn<
    string | FetchArgs,
    unknown,
    FetchBaseQueryError,
    NonNullable<unknown>,
    FetchBaseQueryMeta
  >,
  NonNullable<unknown>,
  any, // 'base'
  any, // 'Category'
  typeof coreModuleName | typeof reactHooksModuleName
>
